"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserFunctionsContext = exports.UserFunctionsContext = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var camelCase_1 = (0, tslib_1.__importDefault)(require("lodash/fp/camelCase"));
var reduce_1 = (0, tslib_1.__importDefault)(require("lodash/fp/reduce"));
var useUserFunctions_1 = require("../hooks/useUserFunctions");
var DEFAULT_PERMISSIONS = {
    closePeriods: false,
    setupInvestedPortfolios: false,
    manageFeeTrackingOptions: false,
    manageTransactionTags: false,
    batchDeleteTransactions: false,
    overwriteReturns: false,
    configureDossierTags: false,
    takeOwnershipOfUnownedObjects: false,
    allOtherManagerFunctions: false,
    transactionEntryInvestment: false,
    transactionEntryClient: false,
    transactionEntryIncomeExpenses: false,
    transactionEntryCash: false,
    valuationEntry: false,
    overwriteAllocations: false,
    updatePrice: false,
    editInvestedPortfolioRelatedItems: false,
    manageLiquidity: false,
    portfolioPlanning: false,
    investmentFeesTracking: false,
    reconcilication: false,
    managePolicy: false,
    journalEntry: false,
    ntPassportDelivery: false,
    approve: false,
    allOtherOperationAnalystFunctions: false,
    generalAddEditItemsInItemExplorer: false,
    viewDossierFiles: false,
    addEditDossierFiles: false,
    viewDossierEvents: false,
    addEditDossierEvents: false,
    addEditTimeSeries: false,
    classificationConfiguration: false,
    editClassifications: false,
    viewResearchTopics: false,
    editResearchTopics: false,
    configureResearchTopics: false,
    permanentlyDeleteDossierFiles: false,
    propertiesConfiguration: false,
    metricsConfiguration: false,
    editMetricsValues: false,
    allOtherInvestmentAnalystFunctions: false,
    configureWebSettings: false,
};
exports.UserFunctionsContext = react_1.default.createContext(DEFAULT_PERMISSIONS);
var UserFunctionsProvider = function (_a) {
    var children = _a.children;
    var data = (0, useUserFunctions_1.useUserFunctions)().data;
    var userFunctions = (0, reduce_1.default)(function (permissions, p) {
        var _a;
        return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, permissions), (_a = {}, _a[(0, camelCase_1.default)(p)] = true, _a));
    }, DEFAULT_PERMISSIONS, data);
    return (react_1.default.createElement(exports.UserFunctionsContext.Provider, { value: userFunctions }, children));
};
exports.default = UserFunctionsProvider;
var useUserFunctionsContext = function () { return (0, react_1.useContext)(exports.UserFunctionsContext); };
exports.useUserFunctionsContext = useUserFunctionsContext;
